import { Link, Stack, Typography } from "@mui/material";
import React, { memo } from "react";
import useRoute from "../../../../../hooks/useRoute";
import { Dashboard } from "../../../../../types/files";
import useStyles from "../styles";

const NameCell: React.FC<{
    dashboard: Dashboard,
    onHover?: (anchor: (HTMLElement|null)[], field?: string, dashboard?: Dashboard) => void,
}> = ({ dashboard, onHover }) => {
    const classes = useStyles();
    const { redirectToDashboard } = useRoute();

    return (<>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" width="100%">
            <Link onClick={() => redirectToDashboard(dashboard.id)}
                underline="hover" target="_self" sx={{ cursor: 'pointer' }}
                onMouseEnter={() => onHover?.([])}>
                <Typography className={classes.title}>
                    {dashboard.title}
                </Typography>
            </Link>
        </Stack>
    </>);
}

export default memo(NameCell);
